var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.44 215.274C933.408 340.242 933.408 542.855 808.44 667.823C701.483 774.779 537.649 790.194 414.298 714.068L279.524 848.842C275.619 852.747 269.287 852.747 265.382 848.842L174.165 757.625C170.26 753.72 170.26 747.388 174.165 743.483L309.108 608.54C233.593 485.29 249.188 321.978 355.891 215.274C480.859 90.3064 683.472 90.3064 808.44 215.274ZM717.93 577.313C642.949 652.294 521.382 652.293 446.401 577.313C371.42 502.332 371.42 380.765 446.401 305.784C521.382 230.803 642.95 230.803 717.93 305.784C792.911 380.765 792.911 502.332 717.93 577.313Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.529 933.695C184.434 937.6 190.766 937.6 194.671 933.695L237.098 891.268C241.003 887.363 241.003 881.031 237.098 877.126L145.881 785.909C141.976 782.004 135.644 782.004 131.739 785.909L89.3122 828.336C85.407 832.241 85.407 838.573 89.3122 842.478L180.529 933.695Z",
    fill: "#FFC700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.218aca966ca21cedd4e51ffaf86415ee.svg";
export { ForwardRef as ReactComponent };